export default {
    install(Vue) {
        Vue.prototype.$toKebabCase = (str) => {
            return str
                .toLowerCase()
                .replace(/[^a-zA-Z0-9\s]/g, '')
                .trim()
                .replace(/\s+/g, '-')
        }
    }
}